import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import AddressContent from '../../../../fragments/address/address-content'
import {FormattedMessage} from "react-intl";

export default props => {
    useStyles(classes)
    const { address, onSelect, showIcon } = props
    return <div onClick={e => onSelect(address)}>
            <div className={classes.Title}>
                {<FormattedMessage id="shipping_address" defaultMessage="Shipping Address" />}
                <Iconfont className={classes.Sword}>&#xe7c7;</Iconfont>
            </div>
            <div className={classes.Container} >
                <div className={classes.Address}>
                    {
                        showIcon && <div className={classes.Icon}>
                            <Iconfont>&#xe691;</Iconfont>
                        </div>
                    }
                    <AddressContent address={address} />
                </div>

            {/*<Iconfont className={classes.Icon}>&#xe690;</Iconfont>*/}
            </div>
    </div>
}